import { Badge } from 'antd'
import cx from 'classnames'
import { useRecoilState } from 'recoil'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { chatChannelStateCommon } from '@pig-common/recoils'
import useGuild from '@pig-common/hooks/useGuild'
import isEmpty from 'lodash/isEmpty'

const Menu = dynamic(() => import('antd/lib/menu'), { ssr: false })

export const roomIndex = [
  {
    name: 'ทุกคน',
    id: 'channel-public',
  },
  {
    name: 'PIGSPIN',
    id: 'channel-pigspin',
  },
  {
    name: 'PIGBET',
    id: 'channel-pigbet',
  },
  {
    name: 'กิลด์',
    id: 'channel-guild',
  },
]

export const namingChatRoom = (
  baseName: string,
  shortForm?: boolean,
  guildName?: string,
) => {
  const result = roomIndex.filter((item: any) => item.id === baseName)
  if (result.length > 0) {
    return result[0].name
  }
  if (baseName.includes('guild')) {
    return !shortForm && guildName ? guildName : 'กิลด์'
  }
  return baseName
}

interface IChatRoomList {
  onSelected?: () => void
}

const ChatRoomList = ({ onSelected }: IChatRoomList) => {
  const [chatChannel, setRecoilChatChannel] = useRecoilState(
    chatChannelStateCommon.chatChannelState,
  )
  const { data: guildData } = useGuild({ enabled: false })

  const goToChatRoom = (room: string) => {
    setRecoilChatChannel({
      ...chatChannel,
      currentChannel: room,
    })
  }

  const listRoomItem = (rooms: string[]) => {
    // Filter guild room, user must have guild then guild room will show
    const filteredRoom = rooms.filter(
      (room) => !(room === 'channel-guild' && isEmpty(guildData?.myGuild)),
    )
    const roomItem = filteredRoom?.map((room) => {
      return {
        key: room,
        className: classNames({
          'ps-chatroom-selector--selected': chatChannel.currentChannel === room,
        }),
        label: (
          <div
            aria-hidden
            className={cx('ps-chatroom-selector__item', {
              'ps-chatroom-selector__item--with-badge':
                chatChannel.unreadMessage[room] > 0,
            })}
            onClick={() => {
              goToChatRoom(
                room === 'channel-guild'
                  ? `channel-guild-${guildData?.myGuild?.info?.guildUid}`
                  : room,
              )
              if (onSelected) onSelected()
            }}
          >
            {chatChannel.unreadMessage[room] > 0 && (
              <Badge className="ps-chatroom-selector__badge" status="error" />
            )}
            <span className={'ps-chatroom-selector__text'}>
              {namingChatRoom(room, true)}
            </span>
          </div>
        ),
      }
    })
    return roomItem
  }

  return (
    <Menu
      className="ps-chatroom-menu"
      items={listRoomItem(chatChannel.channels)}
    />
  )
}

export default ChatRoomList
